module.exports = class Messages {

    constructor(cart) {
        this.data = cart && cart.hasOwnProperty('messages') ? cart.messages : {};
    }

    get all(){
        return {
            "error": this.error,
            "warning": this.warning,
            "info": this.info,
            "success": this.success,
        };
    }

    get hasMessages(){
        return this.error.length || this.warning.length || this.info.length || this.success.length;
    }

    get info(){
        return this.data.hasOwnProperty('info') ? this.data.info : [];
    }

    get success(){
        return this.data.hasOwnProperty('success') ? this.data.success : [];
    }

    get warning(){
        return this.data.hasOwnProperty('warning') ? this.data.warning : [];
    }

    get error(){
        return this.data.hasOwnProperty('error') ? this.data.error : [];
    }
};